<script>
import Dom            from '../app/dom';
import Http           from '../app/http';

import { getParam, client }   from '../app/client';
import { translate }          from '../app/langs';

import Button         from './Button.svelte';
import FormInput      from './FormInput.svelte';
import FormGroup      from './FormGroup.svelte';
import FormSubmit     from './FormSubmit.svelte';
import FormSelect     from './FormSelect.svelte';
import FormSelector   from './FormSelector.svelte';

if(getParam('lang'))
{
	client.languages.unshift(getParam('lang').toLowerCase());
}

function t(str)
{
	return translate(client.languages, str);
}

if(__dev) console.log('Client:', client);

const periodOptions =
[
	{ title: t('once'), value: '' },
	{ title: t('monthly'), value: 'm' },
	{ title: t('yearly'), value: 'y' }
]

const currencyOptions =
[
	{ title: 'CHF', value: 'CHF' },
	{ title: 'EUR', value: 'EUR' },
	{ title: 'USD', value: 'USD' }
]

const genderOptions =
[
	{ title: '', value: '' },
	{ title: t('gender_f'), value: 'f' },
	{ title: t('gender_m'), value: 't' },
]

const countries = t('countries');
const countryOptions = [{ title: '', value: '' }];

for(const code in countries)
{
	countryOptions.push({ title: countries[code], value: code });
}

const formRequest = new Http(__dev ? 'http://localhost:9500' : 'https://api.goetheanum.co');
const formHeaders = { accept: 'application/json' };
const formState = { loading: false };
const formData =
{
	form: 'goetheanum/tv/donate',
    firstname: '',
    lastname: '',
    institution: '',
    company: '',
    address: '',
    address_nr: '',
    zip: '',
    city: '',
    country: '',
    amount: '',
    currency: '',
    gender: '',
    create_account: '',
    username: '',
    email: '',
    period: '',
    payment_text: '',
    payment_language: '',
}

async function formSubmit(ev)
{
	Object.assign(formData, Dom.formData(ev.target));

	if(formState.loading === true) return;

	formState.loading = true;

	const url = await formRequest.post('goetheanum/donate', null, formData, formHeaders);

	if(url)
	{
		if(__dev) console.log(url);
		else return document.location = url;
	}

	formState.loading = false;
}
</script>

<header>
	<div class="container">
		<a href="https://goetheanum.tv" class="mr-auto">
			<img src="logo.png" class="h-10"/>
		</a>
		<a href="#" class="mx-5 btn btn-outline hidden md:block" on:click|preventDefault={history.back.bind(history)}>
			{ t('form_back') }
		</a>
		<!-- <a href="https://goetheanum.tv/pages/bankverbindungen" class="ml-2 btn btn-primary">
			{ t('form_transfer') }
		</a> -->
	</div>
</header>

<main>
	<div class="flex items-center">
		<h1>{ t('form_title') }</h1>
	</div>

	<FormGroup>
		<p class="py-5 text-lg font-normal">
			{ t('form_description') }
		</p>
	</FormGroup>

	<form on:submit|preventDefault={formSubmit} class="mt-5">
		<!-- <FormSelector name="period" options={periodOptions}/> -->
		<FormGroup>
			<FormInput
				title={t('amount')}
				name="amount"
				type="number"
				required={true}
				class="w-full md:w-1/2"
			/>
			<FormSelect
				title={t('currency')}
				name="currency"
				required={true}
				option={client.currency}
				options={currencyOptions}
				class="w-full md:w-1/2"
			/>
		</FormGroup>
		<FormGroup>
			<div class="flex w-full">
				<FormSelect
					title={t('gender')}
					name="gender"
					options={genderOptions}
					required={true}
					class="w-1/3"
				/>
				<FormInput
					title={t('firstname')}
					name="firstname"
					required={true}
					class="w-2/3 ml-5"
				/>
			</div>
			<FormInput title={t('lastname')} name="lastname" required={true} class="w-full"/>
		</FormGroup>
		<FormGroup>
			<FormInput title={t('address')} name="address" class="w-full md:w-1/2"/>
			<FormInput title={t('email')} name="email" required={true} class="w-full md:w-1/2"/>
		</FormGroup>
		<FormGroup>
			<div class="flex w-full">
				<FormInput title={t('zip_code')} name="zip" class="w-1/3"/>
				<FormInput title={t('city')} name="city" class="w-2/3 ml-5"/>
			</div>
			<!-- <FormInput title="Land" class="w-full"/> -->
			<FormSelect
				title={t('country')}
				name="country"
				option={client.country}
				options={countryOptions}
				class="w-full">
			</FormSelect>
		</FormGroup>
		<FormGroup>
			<FormSubmit title={t('send')} loading={formState.loading}/>
		</FormGroup>
		<input type="hidden" name="payment_text" value={t('form_payment_text')}/>
		<input type="hidden" name="payment_language" value={client.languages[0]}/>
	</form>
	<!-- <a
		href="#"
		class="text-white text-center block p-1 mt-5 hover:text-primary transition"
		on:click|preventDefault={() => window.history.back()}
	>
		Zurück zu Goetheanum TV
	</a> -->
	<a href="https://goetheanum.tv/pages/bankverbindungen">
		<button class="btn btn-secondary form-button">{ t('form_transfer') }</button>
	</a>
</main>

<style global>
	body {
		@apply text-white min-h-screen flex flex-col;
		background-color: black;
	}

	h1 {
		@apply text-4xl font-normal mb-2;
	}

	header {
		@apply bg-dark;
	}

	header .container {
		@apply px-4 max-w-7xl flex items-center mx-auto;
	}

	header img {
		margin-top: 15px;
		margin-bottom: 15px;
	}

	main {
		@apply items-center container max-w-4xl w-full py-16 px-4 m-auto;
	}

	input, select {
		@apply appearance-none rounded-none;
	}

    button {
        @apply w-full block font-bold border text-base mt-5 outline-none transition duration-300 rounded;
        @apply text-white border-white;
    }

	.link {
		@apply transition duration-300 text-white hover:text-primary;
	}

	.btn {
		@apply flex items-center justify-center border font-semibold border-transparent px-5 h-11 rounded transition duration-300;
	}

	.btn-link {
		@apply text-white hover:text-primary;
	}

	.btn-primary {
		@apply text-white bg-primary hover:bg-opacity-90 active:bg-opacity-80;
	}

	.btn-secondary {
		@apply text-white bg-dark hover:bg-opacity-90 active:bg-opacity-80;
	}

	.btn-outline {
		@apply text-white hover:text-primary border-white border-opacity-50 hover:border-primary hover:border-opacity-50;
	}

	.btn-outline-primary {
		@apply text-primary border-primary hover:border-opacity-75 active:border-opacity-50;
	}

	.form-title {
		@apply font-normal text-base;
	}

	.form-button {
		@apply w-full mt-5;
		height: 52px;
	}

	@-moz-document url-prefix() {
		select {
			text-indent: -2px;
		}
	}
</style>